<template lang="pug">
component.product(
  :is="createLink ? 'a' : 'div'",
  :href="createLink ? product.detail : false",
  :target="createLink ? '_blank' : false")
  .image
    img(:src="product.image")
  .info
    .title
      span {{ product.name }}
    button(v-if="this.product.pdf", @click="download")
      i.glyph-pdf
      span Download PDF
</template>

<script>
export default {
  name: "ProductTile",
  props: ["product", "showPDF", "createLink"],
  methods: {
    download() {
      const pdf = document.createElement("a");
      pdf.href = this.product.pdf;
      pdf.setAttribute("download", `${this.product.name}.pdf`);
      pdf.click();
    },
  },
};
</script>

<style lang="scss" scoped>
.product {
  display: flex;
  flex-direction: column;
  border: 1px solid $lightGray;
  &:is(a) {
    transition: 0.25s ease;
    text-decoration: none;
    &:hover {
      box-shadow: 0 0 0.5rem rgba($black, 0.0375), 0 0 1rem rgba($black, 0.02);
      .info {
        background: $blue;
      }
      .title {
        color: $white;
      }
    }
  }
}

.image {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  border-bottom: 1px solid $lightGray;
  flex: 1 1 100%;
  img {
    width: auto;
    max-width: 100%;
  }
}

.info {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.75rem;
  gap: 0.5rem;
  transition: inherit;
}

.title {
  text-align: center;
  font-size: 0.75rem;
  font-weight: 400;
  margin: 0;
  text-decoration: none;
  color: $black;
  transition: inherit;
}

button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  appearance: none;
  border: none;
  border-radius: 0;
  background: $buttonPrimaryBackground;
  color: $buttonPrimaryColor;
  transition: 0.25s ease;
  padding: 0.75rem;
  font-weight: 700;
  cursor: pointer;
  font-size: 0.6875rem;

  &:hover {
    background: $buttonPrimaryBackgroundHover;
    color: $buttonPrimaryColorHover;
  }
}
</style>